// extracted by mini-css-extract-plugin
module.exports = {"split-wrapper":"navigation-split_split-wrapper__e8afa","left":"navigation-split_left__FFdCB","right":"navigation-split_right___XrX3","image":"navigation-split_image__2Gy9O"};